// extracted by css-extract-rspack-plugin
export default {"CloseIconContainer":"PvB5P","IconContainer":"IKxj4","BaseSidebarItemRoot":"RHChw","disabled":"JP56i","padded":"SG9AU","SelectableSidebarItemRoot":"bLT3g","isSelected":"vuFXN"};